// @flow
/**
 * ServerRequestException
 */
class ServerRequestException extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ServerRequestException";
  }
}

export default ServerRequestException;
